import { type SyntheticEvent, useState } from 'react'
import { useIntl } from 'react-intl'
import { Button, IconCopySimple, Tooltip } from '@vtex/admin-ui'

type CopySKUCodeProps = {
  skuId: string
  onClick: () => void
}

export const CopySKUCode = ({ skuId, onClick }: CopySKUCodeProps) => {
  const { formatMessage } = useIntl()
  const [isCopied, setIsCopied] = useState(false)

  const handleClick = (evt: SyntheticEvent<HTMLButtonElement>) => {
    evt.stopPropagation()
    evt.preventDefault()
    navigator.clipboard.writeText(skuId).then(() => setIsCopied(true))
    onClick()
  }

  return (
    <Tooltip
      text={formatMessage({
        id: isCopied
          ? 'admin/admin.catalog.copy-sku-code-action-label-success'
          : 'admin/admin.catalog.copy-sku-code-action-label',
        defaultMessage: isCopied ? 'Copied!' : 'Copy SKU Code',
      })}
      placement="top"
    >
      <Button
        className="sku-quick-action"
        variant="neutralTertiary"
        icon={
          <IconCopySimple
            title={formatMessage({
              id: 'admin/admin.catalog.copy-sku-code-action-label',
              defaultMessage: 'Copy SKU Code',
            })}
          />
        }
        onClick={handleClick}
        onMouseLeave={() => setTimeout(() => setIsCopied(false), 300)}
      />
    </Tooltip>
  )
}
